<cdx-carousel2
	[name]="name"
	[itemCount]="items.length"
	[enableArrowNavigation]="enableArrowNavigation"
	[autoRotateInterval]="autoRotateInterval"
	[displayType]="displayType"
	[columns]="columns"
	[align]="align"
	(itemsVisible)="emitVisible($event)"
	(autoRotationCancelled)="autoRotationCancelled = true"
>
	<cdx-carousel2-item
		*ngFor="let item of items; let pos = index"
		[displayType]="displayType"
		[impressionTrackingEnabled]="true"
		[impressionArgs]="impressionArgs[pos]"
		[cdxTrackImpression]="this.promoImpressionArgs[pos]"
		[attr.data-item-id]="item.id"
	>
		<ng-template
			[dynamicComponent]="item.type"
			[data]="item"
			[position]="pos"
			[isCarouselItem]="true"
			[carouselName]="name"
		></ng-template>
	</cdx-carousel2-item>
</cdx-carousel2>
